<template>
    <div style="display: flex">
        <div style="width: 20%; border: 1px solid #dcdee2; margin-top: 1vw; margin-left: 1vw; border-radius: 8px">
            <el-tree :data="data" :props="defaultProps" node-key="deptID" :default-expanded-keys="factoryLevel"
                     @node-click="treeNodeSelect"></el-tree>
        </div>
        <div class="tableOrgBox">
            <LabelContent :title="$t('mechanism.mechanismList')" ref="LabelContent">
                <div slot="btns">
                    <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                    <span v-for="(acc,index) in access" :key="index">
                        <el-button size="small" type="success" @click="addNode()" v-if="acc == 'ORT0001'" style="margin-right: 10px">{{$t('base.add')}}</el-button>
                    </span>
                    <el-button size="small" type="success" @click="exportDepart">{{$t('base.export')}}</el-button>
                    <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                </div>
            </LabelContent>
            <el-table stripe ref="multipleTable" :data="factoryList" v-if="tableContent == 'factory'" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="userName" sortable :label="$t('mechanism.Organization')" show-overflow-tooltip/>
                <el-table-column prop="userAccount" sortable :label="$t('mechanism.factoryDomain')" show-overflow-tooltip/>
                <el-table-column prop="userEmail" :label="$t('mechanism.factoryCode')" show-overflow-tooltip/>
                <el-table-column prop="userEmail" :label="$t('mechanism.factoryAddress')" show-overflow-tooltip/>
                <el-table-column prop="userEmail" label="factoryIdMes" show-overflow-tooltip/>
                <el-table-column prop="userEmail" :label="$t('mechanism.factoryID')" show-overflow-tooltip/>
                <el-table-column :label="$t('base.operation')" width="100">
                    <!--<template slot-scope="scope">
                        &lt;!&ndash;                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />&ndash;&gt;
                        <i class="editBtn iconfont u-youjianbianji" @click="editUser(scope.row)" />
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />
                    </template>-->
                </el-table-column>
            </el-table>
            <el-table stripe ref="multipleTable" :data="workShopList" v-if="tableContent == 'shop'" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="shopName" sortable :label="$t('mechanism.shopName')" show-overflow-tooltip/>
                <el-table-column prop="shopCode" sortable :label="$t('mechanism.shopCode')" show-overflow-tooltip/>
                <el-table-column prop="isActive" :label="$t('base.ifEnable')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!-- <span>{{ scope.row.isActive == true ? $t('base.Enable') : $t('base.Disable') }}</span> -->
                        <span>{{ scope.row.isActive == true ? '启用' : '不启用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="100">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <span v-for="acc in access" :key="acc">
                            <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), editNode(scope.row)"
                                v-if="acc == 'ORT0002'"/>
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" 
                            v-if="acc == 'ORT0003'"/>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-table stripe ref="multipleTable" :data="sectionList" v-if="tableContent == 'vsm'" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="sectionName" sortable :label="$t('mechanism.sectionName')" show-overflow-tooltip/>
                <el-table-column prop="sectionCode" sortable :label="$t('mechanism.sectionCode')" show-overflow-tooltip/>
                <el-table-column prop="isActive" :label="$t('base.ifEnable')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!-- <span>{{ scope.row.isActive == true ? $t('base.Enable') : $t('base.Disable') }}</span> -->
                        <span>{{ scope.row.isActive == true ? '启用' : '不启用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="100">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <span v-for="acc in access" :key="acc">
                            <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), editNode(scope.row)"
                                v-if="acc == 'ORT0002'"/>
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"
                            v-if="acc == 'ORT0003'"/>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-table stripe ref="multipleTable" :data="lineList" v-if="tableContent == 'line'" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="lineName" sortable :label="$t('mechanism.lineName')" show-overflow-tooltip/>
                <el-table-column prop="lineCode" sortable :label="$t('mechanism.lineCode')" show-overflow-tooltip/>
                <el-table-column prop="mesLineCode" :label="$t('mechanism.SAPLineCode')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.mesLineCode }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isActive" :label="$t('base.ifEnable')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!-- <span>{{ scope.row.isActive == true ? $t('base.Enable') : $t('base.Disable') }}</span> -->
                        <span>{{ scope.row.isActive == true ? '启用' : '不启用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="100">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <span v-for="acc in access" :key="acc">
                            <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), editNode(scope.row)"
                                v-if="acc == 'ORT0002'"/>
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"
                            v-if="acc == 'ORT0003'"/>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--新增-->
        <el-dialog :title="updateTitle" width="700px" :visible.sync="updateShow" style="text-align: left">
            <el-form style="margin-left: 12vw" :model="workshopObj" :rules="shopFormRules" :ref="refObj"
                     label-width="100px" class="demo-roleForm" v-if="tableContent == 'shop'">
                <el-form-item :label="$t('mechanism.shopName')" prop="shopName" label-width="120">
                    <!--                <el-input v-model.trim="workshopObj.shopName"></el-input>-->
                    <el-input :value="workshopObj.shopName"
                              @input="e => workshopObj.shopName = validForbid (e)"></el-input>
                </el-form-item>
                <el-form-item :label="$t('mechanism.shopCode')" prop="shopCode" label-width="120">
                    <!--                <el-input v-model.trim="workshopObj.shopCode"></el-input>-->
                    <el-input :value="workshopObj.shopCode"
                              @input="e => workshopObj.shopCode = validForbid (e)"></el-input>
                </el-form-item>
            </el-form>
            <el-form style="margin-left: 12vw" :model="vsmObj" :rules="vsmFormRules" :ref="refObj" label-width="100px"
                     class="demo-roleForm" v-if="tableContent == 'vsm'">
                <el-form-item :label="$t('mechanism.sectionName')" prop="sectionName" label-width="120">
                    <!--                <el-input v-model.trim="vsmObj.sectionName"></el-input>-->
                    <el-input :value="vsmObj.sectionName" @input="e => vsmObj.sectionName = validForbid (e)"></el-input>
                </el-form-item>
                <el-form-item :label="$t('mechanism.sectionCode')" prop="sectionCode" label-width="120">
                    <!--                <el-input v-model.trim="vsmObj.sectionCode"></el-input>-->
                    <el-input :value="vsmObj.sectionCode" @input="e => vsmObj.sectionCode = validForbid (e)"></el-input>
                </el-form-item>
            </el-form>
            <el-form style="margin-left: 12vw" :model="lineObj" :rules="lineFormRules" :ref="refObj" label-width="100px"
                     class="demo-roleForm" v-if="tableContent == 'line'">
                <el-form-item :label="$t('mechanism.lineName')" prop="lineName">
                    <!--                <el-input v-model.trim="lineObj.lineName"></el-input>-->
                    <el-input :value="lineObj.lineName" @input="e => lineObj.lineName = validForbid (e)"></el-input>
                </el-form-item>
                <el-form-item :label="$t('mechanism.lineCode')" prop="lineCode">
                    <!--                <el-input v-model.trim="lineObj.lineCode"></el-input>-->
                    <el-input :value="lineObj.lineCode" @input="e => lineObj.lineCode = validForbid (e)"></el-input>
                </el-form-item>
                <el-form-item :label="$t('mechanism.SAPLineCode')">
                    <!--                <el-input v-model.trim="lineObj.lineCode"></el-input>-->
                    <el-input :value="lineObj.mesLineCode"
                              @input="e => lineObj.mesLineCode = validForbid (e)"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
            <el-button type="primary" @click="updateOrg(refObj, true)">{{$t('base.add')}}</el-button>
        </span>
        </el-dialog>
        <!--编辑-->
        <el-dialog :title="updateTitle" width="700px" :visible.sync="editShow" style="text-align: left">
            <el-form style="margin-left: 12vw" :model="workshopObj" :rules="shopFormRules" :ref="refObj"
                     label-width="100px" class="demo-roleForm" v-if="tableContent == 'shop'">
                <el-form-item :label="$t('mechanism.shopName')" prop="shopName" label-width="120">
                    <!--                <el-input v-model.trim="workshopObj.shopName"></el-input>-->
                    <el-input :value="workshopObj.shopName"
                              @input="e => workshopObj.shopName = validForbid (e)"></el-input>
                </el-form-item>
                <!--<el-form-item label="车间编码" prop="shopCode" label-width="120">
                    <el-input v-model="workshopObj.shopCode"></el-input>
                </el-form-item>-->
                <el-form-item style="margin-left: 1vw" :label="$t('base.ifEnable')" prop="isActive" label-width="120">
                    <el-switch v-model.trim="workshopObj.isActive" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
            </el-form>
            <el-form style="margin-left: 12vw" :model="vsmObj" :rules="vsmFormRules" :ref="refObj" label-width="100px"
                     class="demo-roleForm" v-if="tableContent == 'vsm'">
                <el-form-item :label="$t('mechanism.sectionName')" prop="sectionName" label-width="120">
                    <!--                <el-input v-model.trim="vsmObj.sectionName"></el-input>-->
                    <el-input :value="vsmObj.sectionName" @input="e => vsmObj.sectionName = validForbid (e)"></el-input>
                </el-form-item>
                <!--<el-form-item label="工段编码" prop="sectionCode" label-width="120">
                    <el-input v-model="vsmObj.sectionCode"></el-input>
                </el-form-item>-->
                <el-form-item style="margin-left: 1vw" :label="$t('base.ifEnable')" prop="isActive" label-width="120">
                    <el-switch v-model.trim="vsmObj.isActive" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
            </el-form>
            <el-form style="margin-left: 12vw" :model="lineObj" :rules="lineFormRules" :ref="refObj" label-width="100px"
                     class="demo-roleForm" v-if="tableContent == 'line'">
                <el-form-item :label="$t('mechanism.lineName')" prop="lineName">
                    <!--                <el-input v-model.trim="lineObj.lineName"></el-input>-->
                    <el-input :value="lineObj.lineName" @input="e => lineObj.lineName = validForbid (e)"></el-input>
                </el-form-item>
                <!--<el-form-item label="产线编码" prop="lineCode" label-width="120">
                    <el-input v-model="lineObj.lineCode"></el-input>
                </el-form-item>-->
                <el-form-item :label="$t('mechanism.SAPLineCode')">
                    <!--                <el-input v-model.trim="lineObj.lineCode"></el-input>-->
                    <el-input :value="lineObj.mesLineCode"
                              @input="e => lineObj.mesLineCode = validForbid (e)"></el-input>
                </el-form-item>
                <el-form-item style="margin-left: 1vw" :label="$t('base.ifEnable')" prop="isActive">
                    <el-switch v-model.trim="lineObj.isActive" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="editShow = false">{{$t('base.cancel')}}</el-button>
            <el-button type="primary" @click="updateOrg(refObj, false)">{{$t('base.update')}}</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'organization',
        data() {
            return {
                selectFactory: false,
                tableContent: 'factory',
                data: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                searchParams: {
                    param: {
                        userName: '',
                        startTime: null,
                        endTime: null,
                        userPhone: '',
                        empNumber: '',
                        userAccount: ''
                    },
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                factoryList: [],
                workShopList: [],
                sectionList: [],
                lineList: [],
                updateShow: false,
                editShow: false,
                updateTitle: '',
                refObj: '',
                workshopObj: {
                    shopName: String,
                    shopCode: String
                },
                vsmObj: {
                    sectionName: String,
                    sectionCode: String
                },
                lineObj: {
                    lineName: String,
                    lineCode: String,
                    mesLineCode: String
                },
                shopFormRules: {
                    shopName: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.shopName'),
                            trigger: 'blur'
                        }
                    ],
                    shopCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.shopCode'),
                            trigger: 'blur'
                        }
                    ]
                },
                vsmFormRules: {
                    sectionName: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.sectionName'),
                            trigger: 'blur'
                        }
                    ],
                    sectionCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.sectionCode'),
                            trigger: 'blur'
                        }
                    ]
                },
                lineFormRules: {
                    lineName: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.lineName'),
                            trigger: 'blur'
                        }
                    ],
                    lineCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.lineCode'),
                            trigger: 'blur'
                        }
                    ],
                    mesLineCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('mechanism.SAPLineCode'),
                            trigger: 'blur'
                        }
                    ]
                },
                treeNodeSelected: {},
                factoryLevel: [],
                access: [],
                fcCode: '',
                userInfo: {},
                roles: {}
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.userInfo = this.$store.state.userInfo
            if (this.userInfo.factoryId == 0) {
                //所有工厂数据
            } else {
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                this.roles = userInfo.roles
                for (let i = 0; i < userInfo.roles.length; i++) {
                    if (i == userInfo.roles.length - 1) {
                        this.fcCode += userInfo.roles[i].fcCode
                    } else {
                        this.fcCode += userInfo.roles[i].fcCode + ','
                    }
                }
            }
            this.getData()
        },
        methods: {
            treeNodeSelect(nodes) {
                console.log('nodes', nodes)
                if (nodes.hasOwnProperty('deptCode')) {
                    var node = nodes
                    this.selectFactory = true
                    this.treeNodeSelected = node
                    if (node.deptLevel == 'factory') {
                        this.tableContent = 'shop'
                        let options = {
                            method: 'GET',
                            url: this.$api.getWorkShopList,
                            params: {
                                fcCode: nodes.deptCode
                            }
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.workShopList = response.data
                            }
                        })
                    } else if (node.deptLevel == 'shop') {
                        this.tableContent = 'vsm'
                        let options = {
                            method: 'GET',
                            url: this.$api.getSectionList,
                            params: {
                                shopCode: nodes.deptCode
                            }
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.sectionList = response.data
                            }
                        })
                    } else if (node.deptLevel == 'vsm') {
                        this.tableContent = 'line'
                        let options = {
                            method: 'GET',
                            url: this.$api.getLineList,
                            params: {
                                sectionCode: nodes.deptCode
                            }
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.lineList = response.data
                            }
                        })
                    }
                }
            },
            getData() {
                let options = {
                    method: 'GET',
                    url: this.$api.departTree,
                    params: { fcCode: this.fcCode }
                }
                this.factoryLevel = []
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.setOrgaonization(response.data)
                    }
                })
            },
            setOrgaonization(fctypes) {
                fctypes.forEach(result => {
                    if (result.deptLevel == 'factory') {
                        this.factoryLevel.push(result.deptID)
                    }
                    if (result.deptLevel == 'shop') {
                        this.factoryLevel.push(result.deptID)
                    }
                    if (result.hasOwnProperty('deptCode')) {
                        result.label = result.deptName
                        result.value = result.deptCode
                        result.children = result.child
                        if (result.child != null) {
                            if (result.child.length > 0) {
                                this.setOrgaonization(result.child)
                            }
                        }
                    }
                })
                this.data = fctypes
            },
            addNode() {
                if (this.selectFactory == false) {
                    this.$message.info(this.$t('mechanism.selectFc'))
                    return
                }
                if (this.refObj != null && this.refObj != '') {
                    this.$refs[this.refObj].resetFields()
                }
                if (this.tableContent == 'shop') {
                    this.workshopObj = {
                        shopName: '',
                        shopCode: '',
                        fcCode: this.treeNodeSelected.deptCode
                    }
                    this.refObj = 'workshopObj'
                    this.updateTitle = this.$t('mechanism.AddShop')
                }
                if (this.tableContent == 'vsm') {
                    this.vsmObj = {
                        sectionName: '',
                        sectionCode: '',
                        shopCode: this.treeNodeSelected.deptCode
                    }
                    this.refObj = 'vsmObj'
                    this.updateTitle = this.$t('mechanism.AddSection')
                }
                if (this.tableContent == 'line') {
                    this.lineObj = {
                        lineName: '',
                        lineCode: '',
                        mesLineCode: '',
                        sectionCode: this.treeNodeSelected.deptCode
                    }
                    this.refObj = 'lineObj'
                    this.updateTitle = this.$t('mechanism.AddLine')
                }
                this.updateShow = true
            },
            editNode(row) {
                if (this.selectFactory == false) {
                    this.$message.info(this.$t('mechanism.selectFc'))
                    return
                }
                if (this.refObj != null && this.refObj != '') {
                    this.$refs[this.refObj].resetFields()
                }
                if (this.tableContent == 'shop') {
                    this.workshopObj = JSON.parse(JSON.stringify(row))
                    this.refObj = 'workshopObj'
                    this.updateTitle = this.$t('mechanism.UpdateShop')
                }
                if (this.tableContent == 'vsm') {
                    this.vsmObj = JSON.parse(JSON.stringify(row))
                    this.refObj = 'vsmObj'
                    this.updateTitle = this.$t('mechanism.UpdateSection')
                }
                if (this.tableContent == 'line') {
                    this.lineObj = JSON.parse(JSON.stringify(row))
                    this.$set(this.lineObj, 'mesLineCode', row.mesLineCode)
                    this.refObj = 'lineObj'
                    this.updateTitle = this.$t('mechanism.UpdateLine')
                }
                this.editShow = true
            },
            updateOrg(rules, flag) {
                if (flag) {
                    this.$refs[rules].validate((valid) => {
                        if (valid) {
                            this.formSubmit('POST', flag)
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[rules].validate((valid) => {
                        if (valid) {
                            this.formSubmit('POST', flag)
                        } else {
                            return false
                        }
                    })
                }
            },
            formSubmit(method, flag) {
                var url = ''
                var dataObj = {}
                if (flag) {
                    if (this.tableContent == 'factory') {
                        url = this.$api.addFactory
                    }
                    if (this.tableContent == 'shop') {
                        url = this.$api.addWorkShop
                        dataObj = this.workshopObj
                    }
                    if (this.tableContent == 'vsm') {
                        url = this.$api.addsection
                        dataObj = this.vsmObj
                    }
                    if (this.tableContent == 'line') {
                        url = this.$api.addline
                        dataObj = this.lineObj
                    }
                    let options = {
                        method: method,
                        url: url,
                        data: dataObj
                    }
                    var self = this
                    this.$http.request(options).then(response => {
                        if (response.status == 100) {
                            this.getData()
                            this.treeNodeSelect(this.treeNodeSelected)
                            this.updateShow = false
                        } else {
                            self.$message.error(response.message)
                        }
                    })
                } else {
                    var url = ''
                    var dataObj = {}
                    if (this.tableContent == 'factory') {
                        url = this.$api.editFactory
                    }
                    if (this.tableContent == 'shop') {
                        url = this.$api.editWorkShop
                        dataObj = this.workshopObj
                    }
                    if (this.tableContent == 'vsm') {
                        url = this.$api.editsection
                        dataObj = this.vsmObj
                    }
                    if (this.tableContent == 'line') {
                        url = this.$api.editline
                        dataObj = this.lineObj
                    }
                    let options = {
                        method: method,
                        url: url,
                        data: dataObj
                    }
                    this.$http.request(options).then(response => {
                        if (response.status == 100) {
                            this.getData()
                            this.treeNodeSelect(this.treeNodeSelected)
                            this.editShow = false
                        } else {
                            this.$message.error(response.message)
                        }
                    })
                }
            },
            deleteRow(row) {
                var url = ''
                if (this.tableContent == 'factory') {
                    url = ''
                }
                if (this.tableContent == 'shop') {
                    url = this.$api.delWorkShop + row.shopId
                }
                if (this.tableContent == 'vsm') {
                    url = this.$api.delSection + row.sectionId
                }
                if (this.tableContent == 'line') {
                    url = this.$api.delLine + row.lineId
                }
                this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                url: url
                            })
                            .then(response => {
                                this.getData()
                                this.treeNodeSelect(this.treeNodeSelected)
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getData()
                                this.treeNodeSelect(this.treeNodeSelected)
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getData()
                        this.treeNodeSelect(this.treeNodeSelected)
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.cancel')
                        })
                    })
            },
            async exportDepart() {
                let options = {
                    url: this.$api.exportDepart,
                    method: 'POST',
                    params: {
                        language: this.$t('lang')
                    },
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = this.$t('mechanism.mechanismInfo')  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            }
        }
    }
</script>

<style lang="scss" scoped>
    /*机构管理el-table*/
    /*.tableOrgBox{
            width: 78%;
            padding: 10px;
            margin-top: 0.5vw;
            .el-table {
                border: 1px solid #e4e5e6;
                border-right: none;
            }
        }
        .el-tree{
            width: 100%;
            margin-right: 10vw;
        }
        .el-container .el-container .el-main .pageBox > div{
            display: flex;
        }*/
</style>
